import React from 'react';
import Networks from "../networks/Networks";
import DetailsPageHeader from "../../components/common/headers/DetailsPageHeader";
import NetworkOwnerInfo from "./NetworkOwnerInfo";
import {useLoaderData} from "react-router-dom";
import {usePreloadedQuery} from "react-relay";
import graphql from "babel-plugin-relay/macro";
import {Col, Row} from "react-bootstrap";
import {useUser} from "../../hooks/useUser";
import Attachments from "../../components/attachments/Attachments";
import Notes from "../../components/notes/Notes";

const NetworkOwnerDetails = () => {
    const loader = useLoaderData();
    const data = usePreloadedQuery(graphql`
        query NetworkOwnerDetailsQuery($id: ID!) {
            node(id: $id) {
                id
                ... on NetworkOwner {
                    name
                    ...NetworkOwnerInfo_NetworkOwner
                    networks {
                        id
                    }
                    attachments {
                        ...Attachments
                    }
                    notes {
                        ...Notes
                    }
                }
            }
            allAttachmentCategories {
                ...Fragments_AllAttachmentCategoriesDropdown
            }
        }
    `, loader.networkOwnerDetailsQuery)
    const {hasPermission} = useUser();
  return (
    <>
        <DetailsPageHeader iconText={"Network Owner"} iconType={"user-circle"} title={data.node.name} />
        <Row className={"mb-3"}>
            <Col md={6}>
                <NetworkOwnerInfo networkOwner={data.node} />
            </Col>
            {hasPermission("NetworkOwnerNote.Read") && <Col>
                <Notes notes={data.node.notes}
                       parentId={data.node.id}
                       createPermission={"NetworkOwnerNote.Create"}
                       editPermission={"NetworkOwnerNote.Update"}
                       deletePermission={"NetworkOwnerNote.Delete"}
                       paginationSize={2}
                />
            </Col>}
        </Row>
        {hasPermission("NetworkOwnerAttachment.Read") && <Row>
            <Col>
                <Attachments 
                    parentId={data.node.id} 
                    attachments={data.node.attachments}
                    createPermission={"NetworkOwnerAttachment.Create"}
                    deletePermission={"NetworkOwnerAttachment.Delete"}
                    attachmentCategories={data.allAttachmentCategories} />  
            </Col>
        </Row>}
        {/*<Networks />*/}
    </>
  );
};

export default NetworkOwnerDetails;
